<template>
  <div class="data_dialog">
    <el-dialog
      class="data_dialog"
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
      width="30%"
      :append-to-body="true"
    >
      <template slot="title">
        <div class="title_info">
          <div class="data_dialog_title">{{title}}</div>
        </div>
      </template>

      <el-input placeholder="请输入内容" v-model="input" class="input-with-select">
        <el-button slot="append" @click="searchArr">查询</el-button>
      </el-input>
      <el-checkbox-group @change="checkBox" v-model="checkList" v-if="authorityList.length" ref="checkbox"
                         class="checkbox">
        <el-scrollbar class="gundongtiao">
          <ul>
            <template v-for="(item, index) in authorityList">
              <li :key="index">
                <el-checkbox :label="item.id">
                  <div class="checkBox_message">{{item.name}}</div>
                </el-checkbox>
              </li>

            </template>

          </ul>
        </el-scrollbar>
      </el-checkbox-group>
      <div v-else class="active">暂无数据</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: "数据权限"
      },
      isShow: {
        type: Boolean,
        default: true
      },
      width: {
        type: String,
        default: "35%"
      },
    },
    data() {
      return {
        dialogTableVisible: false,
        checkList: [],
        input: "",
        searchName: '',
        organization: [], // 组织ID
        authorityList: [],  // 组织列表
        dataList: [],
      };
    },
    methods: {
      checkBox(value) {
        this.organization = value.length ? this.authorityList.filter(_ => {
          return value.includes(_.id)
        }) : []
      },
      // 确定按钮
      sureBtn() {
        this.dialogTableVisible = false;
        this.$emit("organization", this.organization);

      },
      // 获取商品类目列表
      getList() {
        this.$axios.post(this.$url.list, {}).then(res => {
          console.log("商品类目列表", res);
          this.authorityList = res.data;
          this.dataList = res.data;
        });
      },
      query(row) {
        this.checkList = row ? row.map(_ => {
          return _.orgId || _.id
        }) : []
      },
      searchArr() {
        if (this.input) {
          this.authorityList = this.authorityList.filter(_ => {
            return _.name.includes(this.input)
          })
        } else {
          this.authorityList = JSON.parse(JSON.stringify(this.dataList))
        }
      },
    },
    destroyed() {

    },
    created() {
      // 组织列表
      this.getList();
    },
    mounted() {
    }
  };
</script>

<style lang='less' scoped>
  .active {
    margin: 30px auto;
    text-align: center;
  }

  .gundongtiao {
    height: 300px;
  }

  .data_dialog {
    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    ::v-deep .input-with-select {
      width: 337px;

      .el-input__inner {
        height: 36px !important;
      }

      .el-input-group__append {
        background-color: rgba(89, 204, 225, 1);
        color: #fff;
        border: 1px solid rgba(221, 221, 221, 1);
        border-left: 0px;
      }
    }

    ::v-deep .el-dialog__footer {
      text-align: center;
    }

    ::v-deep .el-dialog__header {
      padding: 0;
    }

    ::v-deep .el-dialog__body {
      padding-top: 20px;
    }

    .checkbox {
      margin-top: 20px;
      height: 300px;
      overflow: hidden;
      position: relative;

      li {
        height: 46px;
        width: 100%;
        display: flex;
        align-items: center;
        padding-left: 15px;
        box-sizing: border-box;
        background: rgba(240, 242, 245, 1);
      }

      li:nth-child(2n) {
        background-color: #fff;
      }

      .checkBox_message {
        margin-left: 10px;
      }
    }

    .box {
      height: 50px;
      width: 100%;
      display: flex;
      align-items: center;
      padding-left: 15px;
      box-sizing: border-box;
    }

    .title_info {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      padding-top: 20px;
      padding-left: 20px;
      box-sizing: border-box;
    }

    .data_dialog_title {
      font-size: 24px;
      color: rgba(72, 72, 72, 1);
      line-height: 24px;
      margin-right: 5px;
    }
  }
</style>
